import { createAsyncThunk } from '@reduxjs/toolkit'
import { ShowException } from 'store/Application/appActions'
import { projectAPIBuilder } from '../asyncActions/BoMAsyncActions'
import { newProjectActions } from '../newProjectReducer'
import { fetchProject } from './fetchProject'

export const saveProjectRequestedDeliveryDate = createAsyncThunk<
  any,
  any,
  { state: any }
>(
  'project/saveProjectRequestedDeliveryDate',
  async (requestedDeliveryDate: Date, thunkAPI) => {
    const { projectId, api } = projectAPIBuilder(thunkAPI.getState)

    try {
      thunkAPI.dispatch(
        newProjectActions.setActiveProjectProperties({
          requestedDeliveryDate: requestedDeliveryDate,
        })
      )

      await api.SetRequestedDeliveryDate(projectId, requestedDeliveryDate)
    } catch (err) {
      ShowException('Requested Delivery Date', err)
      thunkAPI.dispatch(fetchProject({ projectId: projectId }))
      throw err
    }
  }
)

// export const saveProjectFeasibleDeliveryDate = createAsyncThunk<any, any, { state: any }>(
//   'project/saveProjectFeasibleDeliveryDate',
//   async (feasibleDeliveryDate: Date, thunkAPI) => {
//     const { projectId, api } = projectAPIBuilder(thunkAPI.getState)

//     try {
//       thunkAPI.dispatch(
//         newProjectActions.setActiveProjectProperties({
//           feasibleDeliveryDate: feasibleDeliveryDate,
//         })
//       )

//       await api.SetFeasibleDeliveryDate(projectId, feasibleDeliveryDate)
//     } catch (err) {
//       thunkAPI.dispatch(fetchProject({projectId: projectId}))
//       throw err
//     }
//   }
// )
